"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _default = _propTypes.default.shape({
  suggestion: _propTypes.default.string,
  highlight: _propTypes.default.string,
  data: _propTypes.default.object
});

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9TdWdnZXN0aW9uLmpzIl0sIm5hbWVzIjpbIlByb3BUeXBlcyIsInNoYXBlIiwic3VnZ2VzdGlvbiIsInN0cmluZyIsImhpZ2hsaWdodCIsImRhdGEiLCJvYmplY3QiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztlQUVlQSxtQkFBVUMsS0FBVixDQUFnQjtBQUM3QkMsRUFBQUEsVUFBVSxFQUFFRixtQkFBVUcsTUFETztBQUU3QkMsRUFBQUEsU0FBUyxFQUFFSixtQkFBVUcsTUFGUTtBQUc3QkUsRUFBQUEsSUFBSSxFQUFFTCxtQkFBVU07QUFIYSxDQUFoQixDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5leHBvcnQgZGVmYXVsdCBQcm9wVHlwZXMuc2hhcGUoe1xuICBzdWdnZXN0aW9uOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBoaWdobGlnaHQ6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGRhdGE6IFByb3BUeXBlcy5vYmplY3Rcbn0pO1xuIl19